import BaseRepository from "@/repositories/base/BaseRepository";

class ServicePromotionRepository extends BaseRepository {
  // 获取智能推荐基本信息
  getBrandAdMode() {
    return this.post<any>({
      url: "/ebk-dkb-api/brandAd/getBrandAdMode",
      data: {},
    });
  }

  getBrandAdTimeInterval() {
    return this.post<any>({
      url: "/ebk-dkb-api/brandAd/getBrandAdTimeInterval",
      data: {},
    });
  }

  createBrandAdOrder(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/brandAd/createBrandAdOrder",
      data: params,
    });
  }

  toPayment(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/goldBooth/toPayment",
      data: params,
    });
  }

  getIntelligentRecommendationAdMode(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/intelligentRecommendation/getAdMode",
      data: params,
    });
  }

  getIntelligentRecommendationTimeInterval(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/intelligentRecommendation/getTimeInterval",
      data: params,
    });
  }

  createIntelligentRecommendationOrder(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/intelligentRecommendation/createIntelligentRecommendationOrder",
      data: params,
    });
  }

  // 获取投放位置和帧数
  wxcanapplySeat() {
    return this.post<any>({
      url: "/ebk-dkb-api/wechatAd/wxcanapplySeat",
      data: {},
    });
  }

  // 微信达人按期数、位置获取价格信息
  wxpriceInfos(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/wechatAd/wxpriceInfos",
      data: params,
    });
  }

  // 微信达人-下单接口
  wechatCreate(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/wechatAd/wechatCreate",
      data: params,
    });
  }



  //获取相似酒店订单基本信息
  similarRecommend(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/similar/similarRecommend",
      data: params,
    });
  }

  similarPricePlan(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/similar/pricePlan",
      data: params,
    });
  }

  similarTargetHotel(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/similar/targetHotel",
      data: params,
    });
  }

  // 翻译中文接口
  translateChineseContent(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/internation/ai-translate",
      data: params,
    });
  }

  // 查询程艺推荐等级
  getDecorateGrade(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/decorate/getDecorateGrade",
      data: params,
    });
  }

  // 程艺推荐售卖的日期接口
  shopDecorateRateplan(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/decorate/shopDecorateRateplan",
      data: params,
    });
  }

  // 创建程艺推荐
  createDecorate(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/decorate/createDecorate",
      data: params,
    });
  }

  // 分页获取订单信息
  getPageOrder(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/goldBooth/getPageOrder",
      data: params,
    });
  }

  //获取即将过期订单提醒数据
  getOrderNoticeSum(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/goldBooth/getOrderNoticeSum",
      data: params,
    });
  }

  //获取即将过期订单列表
  getOrderNoticeList(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/goldBooth/getOrderNoticeList",
      data: params,
    });
  }

  //订单详情
  getOrderDetail(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/goldBooth/getOrderDetail",
      data: params,
    });
  }

  //取消订单
  toCancelOrder(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/goldBooth/toCancelOrder",
      data: params,
    });
  }


  //获取流量快车运营数据
  getFlowFlashIndustry(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/flowbus/getFlowFlashIndustry",
      data: params,
    });
  }

  //获取新的数据报告
  getDataReport(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/goldBooth/getDataReport",
      data: params,
    });
  }

  //市场大促活动配置列表
  findMarketPromotionConfig(params: any) {
    return this.get<any>({
      url: "/ebk-dkb-api/market-promotion/find-market-promotion-config",
      data: params,
    });
  }

  //市场活动-创建订单
  orderCreate(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/market-promotion/order-create",
      data: params,
    });
  }

  //创建相似酒店推荐
  createAlike(params: any) {
    return this.post<any>({
      url: "/ebk-dkb-api/similar/createAlike",
      data: params,
    });
  }

  //获取活动配置
  getCommonConfig() {
    return this.get<any>({
      url: "/ebk-dkb-api/config/get-common-config",
      data: {}
    });
  }



}

export default ServicePromotionRepository;
